import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSelect } from "../../CustomControls/CustomSelect";
import { formatConditionGroupLabel, formatConditionOptionLabel } from "../../CustomControls/ConditionSelectFormat";

export const IndicationReason = ({ name, options, value, placeholder, onChange, onBlur, isDisabled }) => {
    const { t } = useTranslation();
    return (
        <CustomSelect
            options={options}
            defaultValue={value}
            name={name}
            placeholder={placeholder}
            onChange={onChange}
            onBlur={onBlur}
            isDisabled={isDisabled}
            getOptionLabel={(option) => formatConditionOptionLabel(option, t)}
            getOptionValue={(option) => option.id}
            formatGroupLabel={formatConditionGroupLabel}
        />
    );
};
